import { render, staticRenderFns } from "./userSwitchPermissionDialog.vue?vue&type=template&id=51cf5701&"
import script from "./userSwitchPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./userSwitchPermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports